import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'unite-close-dialog',
    templateUrl: './close-dialog.component.html',
    styleUrls: ['./close-dialog.component.scss'],
    imports: [MatDialogTitle, TranslateModule, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class CloseDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: CloseDialogData) { }

}

export interface CloseDialogData
{
  message: string;
  description: string;
}